/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { schemasListDestinationTypes } from "../../funcs/schemasListDestinationTypes.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$schemasListDestinationTypes: ToolDefinition = {
  name: "schemas-list-destination-types",
  description: `List Destination Type Schemas

Returns a list of JSON-based input schemas for each available destination type.`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await schemasListDestinationTypes(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
